// extracted by mini-css-extract-plugin
module.exports = {"courseMeta":"CourseHeader_courseMeta__xRg8z","courseAuthor":"CourseHeader_courseAuthor___k4y3"};